import Vue from 'vue'
import Router from 'vue-router'

import Meta from 'vue-meta';
import store from '../store/store'

//axios, moment, swal, nprogress
import axios from 'axios'

Vue.use(Router)
Vue.use(Meta)

/*
 * Backend
 */
import Dashboard from '@/views/backend/Dashboard.vue';

import DashboardPracticeAreas from '@/views/backend/practiceareas/Index.vue';
import DashboardPracticeAreasAdd from '@/views/backend/practiceareas/Add.vue';
import DashboardPracticeAreasEdit from '@/views/backend/practiceareas/Edit.vue';

import DashboardArticles from '@/views/backend/articles/Index.vue';
import DashboardArticlesAdd from '@/views/backend/articles/Add.vue';
import DashboardArticlesEdit from '@/views/backend/articles/Edit.vue';

import DashboardCareers from '@/views/backend/careers/Index.vue';
import DashboardCareersAdd from '@/views/backend/careers/Add.vue';
import DashboardCareersEdit from '@/views/backend/careers/Edit.vue';

import DashboardAbout from '@/views/backend/about/Index.vue';
import DashboardAboutStory from '@/views/backend/about/Story.vue';

import DashboardProfile from '@/views/backend/profile/Index.vue';

/*
 * Frontend
 */
import Home from '@/views/frontend/Home.vue';

import Contact from '@/views/frontend/Contact.vue';
import About from '@/views/frontend/About.vue';

import Careers from '@/views/frontend/Careers.vue';

import Articles from '@/views/frontend/article/Index.vue';
import Article from '@/views/frontend/article/article.vue';

import PracticeAreas from '@/views/frontend/practice/Index.vue';
import Practice from '@/views/frontend/practice/Practice.vue';

import Sitemap from '@/views/frontend/Sitemap.vue';

/*
 * Error 404
 */
import NotFound from '@/views/NotFound.vue';

/*
 * Auth
 */
import AuthIndex from '@/views/auth/Index.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';

const router = new Router({
	mode: 'history',
	routes: [
		/*
		* Backend
		*/
		//Practice areas
		{ path: '/dashboard/practice-areas', name: 'dashpracticeareas', component: DashboardPracticeAreas, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/practice-areas/add', name: 'dashpracticeareasadd', component: DashboardPracticeAreasAdd, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/practice-areas/:practiceid/:practicedash', name: 'dashpracticeareasedit', component: DashboardPracticeAreasEdit, meta: { requiresAuthDashboard: true } },

		//articles
		{ path: '/dashboard/articles', name: 'dasharticles', component: DashboardArticles, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/articles/add', name: 'dasharticlesadd', component: DashboardArticlesAdd, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/articles/:articleid/:articledash', name: 'dasharticlesedit', component: DashboardArticlesEdit, meta: { requiresAuthDashboard: true } },

		//Careers
		{ path: '/dashboard/careers', name: 'dashcareers', component: DashboardCareers, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/careers/add', name: 'dashpcareersadd', component: DashboardCareersAdd, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/careers/:careerid/:careerdash', name: 'dashpcareersEdit', component: DashboardCareersEdit, meta: { requiresAuthDashboard: true } },

		//About
		{ path: '/dashboard/about/overview', name: 'dashabout', component: DashboardAbout, meta: { requiresAuthDashboard: true } },
		{ path: '/dashboard/about/story', name: 'dashaboutstory', component: DashboardAboutStory, meta: { requiresAuthDashboard: true } },

		//Profile
		{ path: '/dashboard/profile', name: 'dashprofile', component: DashboardProfile, meta: { requiresAuthDashboard: true } },

		//Dashboard
		{ path: '/dashboard', name: 'dashboard', component: Dashboard, meta: { requiresAuthDashboard: true } },

		//Auth
		{
			path: '/admin', name: 'login', component: AuthIndex,
			beforeEnter: (to, from, next) => {
				store.state.navState = null;
				next();
			}
		},

		{
			path: '/reset-password', name: 'resetpassword', component: ResetPassword,
			beforeEnter: (to, from, next) => {
				store.state.navState = null;
				next();
			}
		},

		/*
		 * Frontend
		 */
		//Home
		{ path: '/', name: 'home', component: Home, meta: { isFrontend: true } },

		//Contact
		{ path: '/contact-us', name: 'contact', component: Contact, meta: { isFrontend: true } },

		//About
		{ path: '/about-us', name: 'about', component: About, meta: { isFrontend: true } },

		//Careers
		{ path: '/careers', name: 'careers', component: Careers, meta: { isFrontend: true } },

		{ path: '/sitemap', name: 'sitemap', component: Sitemap, meta: { isFrontend: true } },

		//Articles
		{ path: '/articles', name: 'articles', component: Articles, meta: { isFrontend: true } },
		{ path: '/articles/:articledate/:articledash/:articlemask', name: 'article', component: Article, meta: { isFrontend: true } },

		//Practice areas
		{ path: '/practice-areas', name: 'practices', component: PracticeAreas, meta: { isFrontend: true } },
		{ path: '/practice-areas/:practicedash/:practicemask', name: 'practice', component: Practice, meta: { isFrontend: true } },

		/*
		 * Error 404
		 */
		{
			path: '*', name: 'notFound', component: NotFound,
			beforeEnter: (to, from, next) => {
				store.state.navState = null;
				next();
			}
		},

	],
	linkExactActiveClass: "active",
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {

	if (to.meta.requiresAuthDashboard) {
		const authUser = JSON.parse(window.localStorage.getItem('authUser'));
		if (authUser && authUser.access_token) {

			axios.get(APIURL + 'verifyauth?accesstoken=' + authUser.access_token).then((response) => {

				var res = response.data;
				if (res.status == 'success') {
					//Set nav to dashboard
					store.state.navState = 'backend';
					next();
				}
				else {
					localStorage.removeItem("authUser");
					//swal('', 'Your session has expired', 'info');
					next({ name: 'login' });

				}
			})
		}
		else {
			next({ name: 'login' });
		}
	}

	if (to.meta.isFrontend) {
		//Set nav to frontend
		store.state.navState = 'frontend';
		next();
	}
	next();
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js